import styled from 'styled-components';

export const StyledEarningsModal = styled.div`
  width: ${({ theme }) => theme.assetModalWidth};
  padding-top: 1.625rem;
  display: flex;
  flex-direction: column;
`
export const EarningsListWrapper = styled.div`
  margin-top: 0.75rem;
  max-height: 22rem;
  overflow: auto;
  width: 100%;
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  background: #1E2CE9;
`;

export const EarningsList = styled.div`
  width: 100%;
  gap: 1rem;
  display: flex;
  padding: 0.75rem;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`

export const EarningsControls = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  padding: 1.25rem 1.5rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
`;

export const EarningRow = styled.div`
  min-height: 4.25rem;
  height: 4.25rem;
  max-height: 4.25rem;
  gap: 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
`;

export const EarningImageWrapper = styled.div`
  height: 100%;
  min-width: 4.25rem;
  max-width: 4.25rem;
  position: relative;
  border: ${({ $border }) => $border ? 'solid' : 'none'} ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};

  .shop-level {
    font-family: "NeueMachina";
    font-weight: 600;
    font-size: 1.25rem;
    position: absolute;
    bottom:0.5rem;
    left:0.5rem;
  }
`;

export const EarningItemImageBg = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const EarningItemImageBgGrid = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const EarningMainSection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  min-width: 30%;
  max-width: 30%;
`;

export const EarningDescription = styled.div`
  height: 100%;
  grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
`;

export const EarningItemRarity = styled.div`
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-weight: 800;
  font-size: 1.75rem;
`;

export const EarningItemName = styled.div`
  font-family: "NeueMachina";
  font-weight: 600;
  font-size: 1.25rem;
  text-transform: uppercase;
`;

export const EarningPointsValue = styled.div`
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-weight: 400;
  font-size: 3rem;
`;

export const EarningPointsDescription = styled.div`
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-weight: 800;
  font-size: 1.75rem;
`;

export const EarningsNote = styled.div`
  width: 100%;
  text-align: center;
  padding: 1rem;
  padding-bottom: 0;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-weight: 800;
  font-size: 1rem;

  .shade {
    font-weight: 400;
  }
`;
